import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
export default function BidAlerts(prop) {
  const navigate = useNavigate();
  const param = useParams();
  const openPoup = () => {
    prop.funct();
  };
  const redirectToChangeOrder = () => {
    navigate(`/project/${param.id}/changeOrder`,{replace: true});
    window.location.reload(false);
  };
  return prop.pojStatus !== undefined
    ? (() => {
        switch (prop.pojStatus) {
          case "no_bids_submitted":
            return (
              <div className="error-in-bids flex-center bid-alert-view-width">
                <div className="alert mar-bot16">
                  None of the vendor(s) that this project was sent to have
                  submitted a quote. Clicking "Update and Request quotes Again" will
                  allow you to update your project details and request quotes
                  again. Alternatively, you can{" "}
                  <Link to={`/project-details-edit/${prop.projectId}`}>cancel this project</Link>.
                </div>
                <div className="flex justify-end w-d100">
                <button className="blue-btn active" onClick={openPoup}>
                  Update and Request Quotes Again
                </button>
                </div>
                
              </div>
            );

          case "in_cancellation_waiting_for_customer":
            return (
              <div className="error-in-bids flex-center bid-alert-view-width">
                <div className="alert mar-bot16">
                  The vendor has submitted the final charges for work completed
                  on this project. Click Accept to accept the final charges or
                  click Reject to request a revision of the final charges. .
                </div>
                {/* <button className="btn" onClick={openPoup}>
                    Update and Request Quotes Again
                  </button> */}
              </div>
            );

          case "all_bids_rejected":
            return (
              <div className="error-in-bids flex-center bid-alert-view-width">
                <div className="alert mar-bot16">
                  The vendor(s) that this project was sent to have rejected the
                  opportunity to submit a quote. Clicking "Update and Request Quotes
                  Again" will allow you to update your project details and
                  request quotes again. Alternatively, you can.
                  <Link to={`/project-details-edit/${prop.projectId}`}>cancel this project</Link>
                </div>
                <button className="blue-btn active" onClick={openPoup}>
                  Update and Request Quotes Again
                </button>
              </div>
            );

          case "bid_selection_expired":
            return (
              <div className="error-in-bids flex-center bid-alert-view-width" >
                <div className="alert mar-bot16" >
                  The deadline to choose a winning quote has passed. Click "Update
                  and Request Quotes Again" to update your project details and
                  request quotes again.
                  <br />
                  <br />
                  Vendors who previously submitted quotes can then resubmit their
                  original quotes or update their quotes. Alternatively, you can{" "}
                  <Link to={`/project-details-edit/${prop.projectId}`}>cancel this project</Link>.
                </div>
                <div className="flex justify-end w-d100 ">
                <button className="blue-btn active" onClick={openPoup}>
                  Update and Request Quotes Again
                </button>
                </div>
               
              </div>
            );
          case "change_order_requested":
            return (
              <div className="error-in-bids flex-center bid-alert-view-width">
                <div className="alert mar-bot16">
                  There is an outstanding change order requested for this
                  project.<Link to="https://help.cloudwords.com/hc/404">Learn more</Link>
                  <br />
                </div>
                <button className="blue-btn active" onClick={redirectToChangeOrder}>
                  View Project Change Orders
                </button>
              </div>
            );
          case "preparing_change_order_tm":
            return (
              <div className="error-in-bids flex-center bid-alert-view-width">
                <div className="alert mar-bot16">
                  There is an outstanding change order requested for this
                  project.
                  <br />
                </div>
                <button className="blue-btn active" onClick={redirectToChangeOrder}>
                  View Project Changeorders
                </button>
              </div>
            );
          case "vendor_rejected":
            return (
              <div className="error-in-bids flex-center bid-alert-view-width">
                <div className="alert mar-bot16">
                  The deadline to choose a winning quote has passed. Click "Update
                  and Request Quotes Again" to update your project details and
                  request quotes again.
                  <br />
                  <br />
                  Vendors who previously submitted quotes can then resubmit their
                  original quotes or update their quotes. Alternatively, you can{" "}
                  <Link to={`/project-details-edit/${prop.projectId}`}>cancel this project</Link>. change_order
                </div>
                <button className="blue-btn active" onClick={openPoup}>
                  Update and Request Quotes Again
                </button>
              </div>
            );
          default:
            return "";
        }
      })()
    : "";
}
